/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ProjectOverviewSummary,
  ProjectOverviewSummary$inboundSchema,
} from "./projectoverviewsummary.js";

/**
 * Indicates whether metrics are session-based or tool-call-based
 */
export const MetricsMode = {
  Session: "session",
  ToolCall: "tool_call",
} as const;
/**
 * Indicates whether metrics are session-based or tool-call-based
 */
export type MetricsMode = OpenEnum<typeof MetricsMode>;

/**
 * Result of project overview query
 */
export type GetProjectOverviewResult = {
  /**
   * Aggregated project-level summary metrics for a time period
   */
  comparison: ProjectOverviewSummary;
  /**
   * Indicates whether metrics are session-based or tool-call-based
   */
  metricsMode: MetricsMode;
  /**
   * Aggregated project-level summary metrics for a time period
   */
  summary: ProjectOverviewSummary;
};

/** @internal */
export const MetricsMode$inboundSchema: z.ZodMiniType<MetricsMode, unknown> =
  openEnums.inboundSchema(MetricsMode);

/** @internal */
export const GetProjectOverviewResult$inboundSchema: z.ZodMiniType<
  GetProjectOverviewResult,
  unknown
> = z.pipe(
  z.object({
    comparison: ProjectOverviewSummary$inboundSchema,
    metrics_mode: MetricsMode$inboundSchema,
    summary: ProjectOverviewSummary$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "metrics_mode": "metricsMode",
    });
  }),
);

export function getProjectOverviewResultFromJSON(
  jsonString: string,
): SafeParseResult<GetProjectOverviewResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetProjectOverviewResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetProjectOverviewResult' from JSON`,
  );
}
